import React, { useEffect, useState } from 'react';
import {
  Box,
  // Button,
  TextField,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  MenuItem,
} from '@material-ui/core';
import Spinner from '../../common/Spinner/Spinner';
import { Button } from "../../common/Button/Button"
import { toast } from "react-toastify";
import FormModalGroupKnowledgeSession from './FormModalGroupKnowledgeSession';

export default function PersonaDetailGroupKnowledgeSessionTab({ value, index, title, userGroupKnowledgeSesssionPersonaDetails, handleSubmitPersonaDetails, isPersonaLoading, isPersonaFormOpen, setIsPersonaFormOpen, selectedResourceInstanceId, handleFormCancel, setIsFormOpen, isFormOpen, uniqueGroupKnowledgeInstanceId, handleUpdatePersonaDetail, groupKnowledgeAlreadyFilledPersonaInstanceId, resourcesDetails, isTestimonialScreen }) {
  // const [isFormOpen, setIsFormOpen] = useState(false);
  const [formData, setFormData] = useState({
    "nResourceInstanceId": "",
    "Reason for participation": '',
    "Topic": '',
    "Learning": ''
  });
  const [isEdit, setIsEdit] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const [groupKnowledgeResourcesOfUser, setGroupKnowledgeResourcesOfUser] = useState([])
  const [leftResourcesForAddingPersona, setLeftResourcesForAddingPersona] = useState([])
  const [allResourcePersonaDetails, setAllResourcePersonaDetails] = useState([]);

  // useEffect to use the resoyurces availed by the user, here uson it for disabling of the add persona details button, if there isnt any for that category
  useEffect(() => {
    if (resourcesDetails?.KnowledgeSessions) {
      setGroupKnowledgeResourcesOfUser(resourcesDetails.KnowledgeSessions);

      let allKnowledgeSession = resourcesDetails?.KnowledgeSessions;
      console.log(allKnowledgeSession, ">>>>allKnowledgeSession");

      let fillingDefaultDataInPersonaDetails = allKnowledgeSession.map((resourceObj) => {
        // checking if persona details exist for the instanceId if exists spread it with resource details and if not set default empty keys
        let findPersonaForInstanceId = userGroupKnowledgeSesssionPersonaDetails?.find((personaObj) => personaObj?.nResourceInstanceId == resourceObj?.nResourceInstanceId);
        if (findPersonaForInstanceId) {
          return {
            ...findPersonaForInstanceId,
            ...resourceObj,
            "Topic": resourceObj["ResourcePackageTitle"] ? resourceObj["ResourcePackageTitle"] : "",
            "isAlreadyPersonaExisting": true, // if persona already existitng then flag for all persona to show edit button
          }
        } else {
          return {
            "nResourceInstanceId": "",
            "Reason for participation": '',
            "Learning": '',
            ...resourceObj,
            "Topic": resourceObj["ResourcePackageTitle"] ? resourceObj["ResourcePackageTitle"] : "",
            "isAlreadyPersonaExisting": false, // if persona not already existitng then flag for all persona to show add button
          }
        }
      })

      setAllResourcePersonaDetails([...fillingDefaultDataInPersonaDetails])

      console.log(userGroupKnowledgeSesssionPersonaDetails, ">>>>userGroupKnowledgeSesssionPersonaDetails in group knowledge useEffect")
      console.log(uniqueGroupKnowledgeInstanceId, ">>>>uniqueGroupKnowledgeInstanceId");


      const alreadyFilledPersonaResourceIds = userGroupKnowledgeSesssionPersonaDetails?.map((obj) => {
        const { nResourceInstanceId } = obj;
        return nResourceInstanceId;
      })
      console.log(alreadyFilledPersonaResourceIds, ">>>alreadyFilledPersonaResourceIds group knowledge");

      if (alreadyFilledPersonaResourceIds) {
        const personaDetailResourceAddingLeft = uniqueGroupKnowledgeInstanceId?.filter((resourceId) => !alreadyFilledPersonaResourceIds.includes(resourceId))
        console.log(personaDetailResourceAddingLeft, ">>>>personaDetailResourceAddingLeft");
        setLeftResourcesForAddingPersona(personaDetailResourceAddingLeft);
      }
    } else {
      setGroupKnowledgeResourcesOfUser([]);
    }
    // setLoading(false);
  }, [resourcesDetails, uniqueGroupKnowledgeInstanceId, userGroupKnowledgeSesssionPersonaDetails]);

  if (value !== index) return null;

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleFormToggle = () => {
    console.log(">>>Entered formtoggle func");

    setIsFormOpen(!isFormOpen);
    // setIsPersonaFormOpen(!isPersonaFormOpen)
  };

  // useEffect(()=>{
  //   if(isPersonaFormOpen){
  //     setIsFormOpen(true);
  //     setIsPersonaFormOpen(true)
  //   }
  // })

  const handleAddEditButton = (rowData, action) => {
    if (action === "edit") {
      console.log(rowData, ">>>>rowData on handleEdit exprt consult");
      setIsFormOpen(true);
      setFormData(rowData);
      setIsEdit(true);
      setIsModalOpen(true)
    } else if (action === "add") {
      console.log(rowData, ">>>>rowData on handleEdit exprt consult");
      setIsFormOpen(true);
      setFormData(rowData);
      setIsEdit(false);
      setIsModalOpen(true)
    }

  }

  const handleUpdateButtonClick = (formData) => {
    console.log(formData, ">>>>update form data group know");

    if (!formData["nResourceInstanceId"]) {
      toast(String("Resource-ID is required"), {
        autoClose: 5000,
        type: toast.TYPE.ERROR,
      });
      setIsModalOpen(false)
    } else {
      const { nResourceInstanceId,
        "Reason for participation": reasonOfParticipation,
        Topic,
        Learning,
        ...resFormData } = formData

      console.log(resFormData, ">>>>>resFormData in update group knowledge")
      handleUpdatePersonaDetail(
        {
          "Type": "Group_knowledge_session",
          "subType": "Group knowledge session",
          "nResourceInstanceId": nResourceInstanceId,
          "fields": {
            "Reason for participation": reasonOfParticipation,
            "Topic": Topic,
            "Learning": Learning
          }
        });

      setFormData({
        "nResourceInstanceId": "",
        "Reason for participation": '',
        "Topic": '',
        "Learning": ''
      })
      setIsEdit(false)
      setIsModalOpen(false)
    }
  }

  // // form to submit new data
  // const renderForm = () => (
  //   <Box className={`${isPersonaLoading && "set-opacity"}`}>
  //     {isPersonaLoading && <Spinner className="center-screen" />}
  //     {/* <TextField
  //       name="nResourceInstanceId"
  //       label="Resource Instance Id"
  //       // value={selectedResourceInstanceId}
  //       value={formData["nResourceInstanceId"]}
  //       onChange={handleInputChange}
  //       fullWidth
  //       margin="normal"
  //     /> */}
  //     <TextField
  //       select
  //       name="nResourceInstanceId"
  //       label="Resource Instance Id"
  //       value={formData["nResourceInstanceId"]}
  //       onChange={handleInputChange}
  //       fullWidth
  //       margin="normal"
  //       SelectProps={{
  //         MenuProps: {
  //           PaperProps: {
  //             style: {
  //               maxHeight: 200, // height of dropdown
  //               width: 300,     // width of dropdown
  //             },
  //           },
  //         },
  //       }}
  //     >
  //       {uniqueGroupKnowledgeInstanceId.map((option) => (
  //         <MenuItem key={option} value={option}>{option}</MenuItem>
  //       ))}
  //     </TextField>

  //     <TextField
  //       name="Reason for participation"
  //       label="Reason for participation"
  //       value={formData["Reason for participation"]}
  //       onChange={handleInputChange}
  //       fullWidth
  //       margin="normal"
  //     />

  //     <TextField
  //       name="Topic"
  //       label="Topic"
  //       value={formData["Topic"]}
  //       onChange={handleInputChange}
  //       fullWidth
  //       margin="normal"
  //     />

  //     <TextField
  //       name="Learning"
  //       label="Learning"
  //       value={formData["Learning"]}
  //       onChange={handleInputChange}
  //       fullWidth
  //       margin="normal"
  //     />
  //   </Box>
  // );

  // render table to display data
  const renderTable = () => (
    <TableContainer component={Paper} style={{ maxHeight: "405px", overflowY: 'auto' }}>
      <Table stickyHeader>
        <TableHead>
          <TableRow>
            <TableCell>Resource Id</TableCell>
            <TableCell>Topic</TableCell>
            {/* <TableCell>Reason for participation</TableCell>
            <TableCell>Learning</TableCell>
            {!isTestimonialScreen && <TableCell>Action</TableCell>} */}
          </TableRow>
        </TableHead>
        <TableBody>
          {/* {
            userGroupKnowledgeSesssionPersonaDetails ? (
              userGroupKnowledgeSesssionPersonaDetails.map((row, index) => (
                <TableRow key={index}>
                  <TableCell>{row["nResourceInstanceId"] ?? "N/A"}</TableCell>
                  <TableCell>{row["Reason for participation"] ?? "N/A"}</TableCell>
                  <TableCell>{row["Topic"] ?? "N/A"}</TableCell>
                  <TableCell>{row["Learning"] ?? "N/A"}</TableCell>
                  <TableCell><Button onClick={() => handleAddEditButton(row)}>Edit</Button></TableCell>
                </TableRow>
              ))
            ) : <TableRow>
              <TableCell colSpan={10} align="center">
                No Data Found
              </TableCell>
            </TableRow>
          } */}

          {
            allResourcePersonaDetails ? (
              allResourcePersonaDetails.map((row, index) => (
                <TableRow key={index}>
                  <TableCell>{row["nResourceInstanceId"] ?? ""}</TableCell>
                  <TableCell>{row["Topic"] ? row["Topic"] : ""}</TableCell>
                  {/* <TableCell>{row["Reason for participation"] ?? ""}</TableCell>
                  <TableCell>{row["Learning"] ?? ""}</TableCell>
                  {
                    !isTestimonialScreen && (
                      <TableCell>
                        {
                          row["isAlreadyPersonaExisting"] ? (
                            <Button onClick={() => handleAddEditButton(row, "edit")}>{"Edit"}</Button>
                          ) : (
                            <Button onClick={() => handleAddEditButton(row, "add")}>{"Add"}</Button>
                          )
                        }
                      </TableCell>
                    )
                  } */}
                </TableRow>
              ))
            ) : <TableRow>
              <TableCell colSpan={10} align="center">
                No Data Found
              </TableCell>
            </TableRow>
          }
        </TableBody>
      </Table>
    </TableContainer>
  );

  // handleFormSubmit
  const submitGroupKnowledgePersonaForm = () => {
    console.log(">>>Submit clicked ");
    const { nResourceInstanceId,
      "Reason for participation": reasonOfParticipation,
      Topic,
      Learning,
      ...resFormData } = formData

    let data = {
      "Type": "Group_knowledge_session",
      "subType": "Group knowledge session",
      "nResourceInstanceId": nResourceInstanceId,
      "fields": {
        "Reason for participation": reasonOfParticipation,
        "Topic": Topic,
        "Learning": Learning
      }
    }

    console.log(data, ">>>Submitting group knowledge data");

    handleSubmitPersonaDetails(data);
    if (!isPersonaLoading) {
      // handleFormToggle(isPersonaFormOpen);
      setFormData({
        "nResourceInstanceId": "",
        "Reason for participation": '',
        "Topic": '',
        "Learning": ''
      })

      handleFormToggle();
      setIsModalOpen(false);
    }
  }

  const handleCancelForm = () => {
    setIsFormOpen(false);
    setIsEdit(false);
    setFormData({
      "nResourceInstanceId": "",
      "Reason for participation": '',
      "Topic": '',
      "Learning": ''
    })

    setIsModalOpen(false);
  }

  console.log(userGroupKnowledgeSesssionPersonaDetails, ">>>>>userGroupKnowledgeSesssionPersonaDetails in tab");
  console.log(groupKnowledgeResourcesOfUser, ">>>>groupKnowledgeResourcesOfUser")
  // console.log(formData, ">>>>>formData");
  // console.log(isPersonaLoading, ">>>isPersonaLoading in grp kn persona");
  // console.log(isPersonaFormOpen, ">>>>> isPersonaFormOpen");
  console.log(isFormOpen, ">>>>isFormOpen");
  console.log(allResourcePersonaDetails, ">>>>allResourcePersonaDetails")
  return (
    <Box style={{ padding: '16px' }} className={`${isPersonaLoading && "set-opacity"}`}>
      {isPersonaLoading && <Spinner className="center" />}
      <Typography variant="h6" style={{ fontWeight: 'bold', color: '#6D1B7B' }}>
        {title}
      </Typography>

      {/* {isFormOpen ? renderForm() : renderTable()} */}
      {/* {isPersonaFormOpen ? renderForm() : renderTable()} */}
      {renderTable()}

      {/* <Button
        variant="contained"
        color="primary"
        onClick={handleFormToggle}
        style={{ marginTop: 20, width: '100%' }}
      >
        {isFormOpen ? 'Cancel' : 'Add New Opportunity'}
      </Button> */}
      {/* <Box>
        {
          isFormOpen ?
            // isPersonaFormOpen ?
            <Box display="flex" justifyContent="flex-end" padding="0px 20px" style={{ gap: "20px" }}>
              <Button
                variant="contained"
                color="primary"
                onClick={() => handleCancelForm()}
                // onClick={handleFormCancel}
                style={{ marginTop: 20, backgroundColor: "#75287C", color: "#fff", textTransform: "none" }}
              >
                Cancel
              </Button>
              {
                !isEdit ? <Button
                  variant="contained"
                  color="primary"
                  // onClick={handleFormToggle}
                  onClick={submitGroupKnowledgePersonaForm}
                  style={{ marginTop: 20, backgroundColor: "#75287C", color: "#fff", textTransform: "none" }}
                >
                  Submit
                </Button> : <Button
                  variant="contained"
                  color="primary"
                  // onClick={handleFormToggle}
                  onClick={() => handleUpdateButtonClick(formData)}
                  style={{ marginTop: 20, backgroundColor: "#75287C", color: "#fff", textTransform: "none" }}
                >
                  Update
                </Button>
              }



            </Box>
            :
            <Box display="flex" justifyContent="flex-end" padding="0px" style={{ gap: "20px" }}>
              <Button
                variant="contained"
                color="primary"
                // onClick={handleFormToggle}
                onClick={()=>setIsModalOpen(true)}
                style={{ marginTop: 20, width: '300px', backgroundColor: "#75287C", color: "#fff", textTransform: "none" }}
              >
                Add New Persona Detail
              </Button>
            </Box>
          // ""
        }

        


      </Box> */}

      {/* <Box>
        <Box display="flex" justifyContent="flex-end" padding="0px" style={{ gap: "20px" }}>
          <Button
            variant="contained"
            color="primary"
            // onClick={handleFormToggle}
            onClick={() => setIsModalOpen(true)}
            style={{ marginTop: 20, width: '300px', backgroundColor: "#75287C", color: "#fff", textTransform: "none" }}
            disabled={groupKnowledgeResourcesOfUser.length <= 0 || leftResourcesForAddingPersona.length <= 0}
          >
            Add New Persona Detail
          </Button>
        </Box>
      </Box> */}

      <FormModalGroupKnowledgeSession
        open={isModalOpen}
        // onClose={() => setIsModalOpen(false)}
        onClose={() => handleCancelForm()}
        isPersonaLoading={isPersonaLoading}
        formData={formData}
        handleInputChange={handleInputChange}
        uniqueGroupKnowledgeInstanceId={uniqueGroupKnowledgeInstanceId}
        isEdit={isEdit}
        handleUpdateButtonClick={handleUpdateButtonClick}
        submitGroupKnowledgePersonaForm={submitGroupKnowledgePersonaForm}
        groupKnowledgeAlreadyFilledPersonaInstanceId={groupKnowledgeAlreadyFilledPersonaInstanceId}
      />
    </Box>
  );
}
